import { TextBlockContent } from "../types";

export function markAnswer(content: TextBlockContent): void {}
